import { render, staticRenderFns } from "./XXXTabMob.vue?vue&type=template&id=5e5bcc0d&scoped=true"
import script from "./XXXTabMob.vue?vue&type=script&lang=js"
export * from "./XXXTabMob.vue?vue&type=script&lang=js"
import style0 from "./XXXTabMob.vue?vue&type=style&index=0&id=5e5bcc0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5bcc0d",
  null
  
)

export default component.exports